import Banner from "../../Componant2/Banner/Banner";
import About from "../../Componant2/About/About";
import Service from "../../Componant2/Service/Service";
import Rating from "../../Componant2/Rating/Rating";
import Project from "../../Componant2/Project/Project";
import Faq from "../../Componant2/Faq/Accordion/Faq";
import Brand from "../../Componant2/Brand/Brand";
import Donation from "../../Componant2/Donations/Donation";
import Testimonial from "../../Componant2/Testimonial/Testimonial";
import ContentSlider2 from "../../Componant2/ContentSlider2/ContentSlider2";
import Blog from "../../Componant2/Blog/Blog";

const Home2 = () => {
  return (
    <>
      <Banner />
      <About />
      <Service />
      <Rating />
      <Project />
      <Faq />
      <Brand />
      <Donation />
      <Testimonial />
      <ContentSlider2/>
      <Blog />
    </>
  );
};

export default Home2;
